/* Use Shopify's Section Rendering API for the existing Prestige cart refresh. */
(function () {
  if (!window.fetch || window.__jzCartSectionRenderingInstalled) return;

  window.__jzCartSectionRenderingInstalled = true;
  var nativeFetch = window.fetch.bind(window);

  function normalizeUpsellHeading() {
    var heading = document.querySelector('#sidebar-cart .cart_cross-sell > .Heading');
    if (heading && /free shipping/i.test(heading.textContent)) heading.textContent = 'You may also like';
  }

  function syncDrawerCount(count) {
    var countLabel = document.querySelector('#sidebar-cart .CartDrawer__Count');
    if (countLabel && typeof count === 'number') countLabel.textContent = '(' + count + ')';
  }

  document.addEventListener('DOMContentLoaded', function () {
    var cart = document.getElementById('sidebar-cart');
    if (!cart) return;
    new MutationObserver(normalizeUpsellHeading).observe(cart, { childList: true, subtree: true });
    normalizeUpsellHeading();
  });

  window.fetch = function (input, init) {
    var requestUrl = typeof input === 'string' ? input : input && input.url;
    if (!requestUrl) return nativeFetch(input, init);

    var parsedUrl;
    try {
      parsedUrl = new URL(requestUrl, window.location.origin);
    } catch (error) {
      return nativeFetch(input, init);
    }

    if (/\/cart\/(add|change|update)\.js$/.test(parsedUrl.pathname)) {
      return nativeFetch(input, init).then(function (response) {
        if (!response.ok) return response;
        return response.clone().json().then(function (cart) {
          syncDrawerCount(cart.item_count);
          return response;
        }).catch(function () { return response; });
      });
    }

    if (!/\/cart\/?$/.test(parsedUrl.pathname) || parsedUrl.searchParams.get('view') !== 'drawer') {
      return nativeFetch(input, init);
    }

    /* Render the layout section on the page the customer is already viewing.
       The cart template intentionally omits the drawer section. */
    parsedUrl = new URL(window.location.href);
    parsedUrl.searchParams.delete('view');
    parsedUrl.searchParams.delete('timestamp');
    parsedUrl.searchParams.delete('sections');
    parsedUrl.searchParams.set('sections', 'cart-drawer');

    return nativeFetch(parsedUrl.toString(), init).then(function (response) {
      if (!response.ok) return response;

      return response.clone().json().then(function (sections) {
        var sectionHtml = sections && sections['cart-drawer'];
        if (!sectionHtml) return response;

        var sectionDocument = document.createElement('div');
        sectionDocument.innerHTML = sectionHtml;
        var refreshedCount = sectionDocument.querySelector('.CartDrawer__Count');
        if (refreshedCount) {
          var countMatch = refreshedCount.textContent.match(/\d+/);
          if (countMatch) syncDrawerCount(parseInt(countMatch[0], 10));
        }

        return new Response(sectionHtml, {
          status: response.status,
          statusText: response.statusText,
          headers: { 'Content-Type': 'text/html; charset=utf-8' }
        });
      }).catch(function () {
        return response;
      });
    });
  };
})();
